import React, { useContext, useState } from "react";
import { StateContext } from "./state";

export const Search = ({ index }) => {
  const { properties, activeSearch, setHotelsHandler } = useContext(
    StateContext
  );
  const [filteredProperties, setFilteredProperties] = useState(properties);
  const countries = new Set();
  const cities = new Set();

  const handleClick = (id) => {
    const hotel = properties.find((i) => i.ppty_id === id);
    setHotelsHandler(hotel, activeSearch);
  };

  const filterHotels = (e) => {
    const { value } = e.target;
    if (value === "") {
      setFilteredProperties(properties);
    } else {
      const hotels = properties.filter(
        (p) => p.title.toLowerCase().indexOf(value) > -1
      );
      setFilteredProperties(hotels);
    }
  };

  const filteredPropertiesList = filteredProperties.map((p) => {
    const list = (
      <>
        {!countries.has(p.country_name) && <h3>{p.country_name}</h3>}
        {!cities.has(p.city_name) && <em>{p.city_name}</em>}
        <p
          onClick={() => {
            handleClick(p.ppty_id);
            document.querySelectorAll(".hotel-selects select")[
              index - 1
            ].value = p.ppty_id.toString();
          }}
        >
          {p.title}
        </p>
      </>
    );
    countries.add(p.country_name);
    cities.add(p.city_name);
    return list;
  });

  return (
    <div className="search-rfp">
      <input
        placeholder={Drupal.t("Search here")}
        type="search"
        onInput={filterHotels}
      />
      <ul className="search-rfp-listing">{filteredPropertiesList}</ul>
    </div>
  );
};
